(function() {
  
  /**
   * @ngdoc factory
   * @name RcProductList
   * @description Model for a product list, wrapped for reseller console
   */
  angular
    .module('rcEntities.rcProductList', ['binky.core.product'])
    .factory('RcProductList', getProductListModel);

  /* @ngInject */
  function getProductListModel($injector, $q, _, DemoMode, Product, ProductList) {
    class RcProductList extends ProductList {
      /**
       * @description Method to determine if any products in the list are SDL products
       * @returns {Boolean} true if some products are SDL, false if none are
       */
      hasSharedDeviceLicenseProducts() {
        return _.some(this.items, product =>
          product.fulfillableItemList.hasLaboratoryLicenseManagement()
        );
      }

      /**
       * @description Method to refresh Product list from back-end.
       * @returns {Promise} resolves to ProductList on success, else rejects with error
       */
      refresh() {
        if (DemoMode.isEnabled()) {
          // Do not call JIL in demo mode; set up the list via MiniJil.
          const deferred = $q.defer();
          this.$promise = deferred.promise;
          // avoid circular dependency
          const MiniJil = $injector.get('MiniJil');
          MiniJil.getProducts(this.orgId).then(responseData => {
            this.items = _.map(responseData, item => Product.apiResponseTransformer(item));
            deferred.resolve(this);
          });
          return deferred.promise;
        } else {
          return super.refresh();
        }
      }

      /**
       * @description Method to fetch the RcProductList.
       * @param {Object} [options] - options to configure the product list.
       * @returns {ProductList} the fetched RcProductList.
       */
      static get(options) {
        // make it a singleton to avoid calling refresh all the time. If the orgId doesn't match,
        // create a new one (when we've switched customer detail views).
        if (!RcProductList.model || RcProductList.model.orgId !== options.orgId || RcProductList.model.contractId !== options.contractId) {
          RcProductList.model = new RcProductList(options);
          RcProductList.model.refresh();
        }

        return RcProductList.model;
      }
    }

    return RcProductList;
  }
})();
